<script setup>
import PillButton from "@/components/approval-center/partials/buttons/PillButton.vue";
import {useQueryClient} from "@tanstack/vue-query";
import {ApprovalCategoryEnum, useApprovalCenterFilters} from "@/composables/approval-center/useApprovals";

const {activeFilter, setActiveFilter, showAll, filters, totalCount} = useApprovalCenterFilters();
const queryClient = useQueryClient();

const approvalCategoryFilters = {
  [ApprovalCategoryEnum.BLOG_STRATEGY]: 'Blog Strategy',
  [ApprovalCategoryEnum.BLOG_POST]: 'Blog Post',
  [ApprovalCategoryEnum.GBP_POST]: 'Google Business Profile Post',
  [ApprovalCategoryEnum.TONE_OF_VOICE]: 'Tone-of-Voice',
  [ApprovalCategoryEnum.GBP_DESCRIPTION]: 'Google Business Profile Description',
  [ApprovalCategoryEnum.GBP_FAQ]: 'FAQ',
  [ApprovalCategoryEnum.GBP_NEW_QUESTIONS]: 'New Questions',
  [ApprovalCategoryEnum.GBP_REVIEWS]: 'Reviews',
  [ApprovalCategoryEnum.HEADING]: 'Page Headings',
  [ApprovalCategoryEnum.H2_HEADING]: 'H2 Headings',
  [ApprovalCategoryEnum.WEBSITE_COPY]: 'Website Copy',
  [ApprovalCategoryEnum.META_DESCRIPTION]: 'Meta Description',
  [ApprovalCategoryEnum.PAGE_TITLE]: 'Page Title',
  [ApprovalCategoryEnum.NEW_PAGE_CONTENT]: 'New Page Content',
};

// Subscribe to the query cache to update the filters when the data changes
queryClient.getQueryCache().subscribe(() => {
  const allQueries = queryClient.getQueriesData( { queryKey: ["approvals"]})

  filters.value = allQueries
    .filter(queryData => Array.isArray(queryData[0]))
    .map(queryData => {
      const secondaryQueryKey = queryData[0][1];
      const total = queryData[1]?.pages[0]?.meta?.total ?? 0;

      if (activeFilter.value === secondaryQueryKey && total === 0) {
        showAll()
      }

      return {
        category: secondaryQueryKey,
        text: approvalCategoryFilters[secondaryQueryKey],
        count: total,
      }
    })
    .filter(filter => filter.count > 0);
});
</script>

<template>
  <div class="tw-flex tw-flex-wrap tw-gap-2 tw-p-1 tw-align-middle">
    <PillButton
      v-if="totalCount > 0"
      text="All"
      :count="totalCount"
      :active="!activeFilter"
      @click="showAll"
    />
    <PillButton
      v-for="({text, count, category}, key) in filters"
      :key="key"
      :text="text"
      :count="count"
      :active="activeFilter === category"
      @click="() => setActiveFilter(category)"
    />
  </div>
</template>
